import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, } from '@headlessui/vue';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { arrayToQueryStringParameter, asArray, ucfirst } from '@/utils/utils';
import { ChevronDownIcon, MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/20/solid';
import axios from 'axios';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { statsCache } from '@/stores/statsCache.ts';
import { useArticlesStore } from '@/stores/articles.ts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AjaxQueryWithSearchDropdown',
    props: {
        filterKey: { type: String, required: true },
        filterKeyName: { type: String, required: false },
        filterOptions: { type: Array, required: true },
        by: { type: String, required: false },
        multiple: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
        searchPlaceholder: { type: String, required: false, default: () => (useI18n().t('Type to filter…')) },
        defaultValue: { type: [Object, Array], required: false, default: null },
        pagination: { type: Boolean, required: false, default: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const articleStore = useArticlesStore();
        const options = ref([]);
        const ajaxIsLoading = ref(false);
        const ajaxError = ref(false);
        const state = ref('closed');
        const comboboxButton = ref(null);
        // watch(
        //   () => filterOptions,
        //   (newFilters) => {
        //     options.value = newFilters
        //   },
        // )
        const query = ref('');
        const onInput = (event) => {
            query.value = event.target.value;
        };
        const filteredOptions = computed(() => {
            const sortedOptions = [...options.value];
            const order = articleStore.order[__props.filterKey];
            if (order) {
                sortedOptions.sort((a, b) => (order.indexOf(a.key) === -1 ? Infinity : order.indexOf(a.key)) -
                    (order.indexOf(b.key) === -1 ? Infinity : order.indexOf(b.key)));
            }
            return query.value?.trim() === ''
                ? sortedOptions
                : sortedOptions.filter((option) => option.label.toLowerCase().includes(query.value.toLowerCase()));
        });
        function trackOpenState() {
            // if (open) {
            //   trackedOpenState.open = selectedOptions.value
            //
            //   if (!debounceInterval) {
            //     debounceInterval = setInterval(() => {
            //       limit.value = limit.value + 50
            //
            //       if (filteredDebouncedOptions.value.length >= options.value.length) {
            //         limit.value = filteredDebouncedOptions.value.length
            //         clearInterval(debounceInterval)
            //       }
            //     }, 100)
            //   }
            // } else {
            //   trackedOpenState.closed = selectedOptions.value
            //   clearInterval(debounceInterval)
            //   debounceInterval = null
            //   limit.value = 100
            // }
            //
            // if (isOpen.value !== open) {
            //   isOpen.value = open
            //   if (!open) {
            //     let newQuery = {...route.query}
            //     if (trackedOpenState.open === trackedOpenState.closed) {
            //       delete newQuery[filterKey]
            //     } else {
            //       newQuery = {
            //         ...newQuery,
            //         ...{
            //           [filterKey]: multiple
            //             ? selectedOptions.value?.map(({key}) => key)
            //             : selectedOptions.value?.key,
            //         },
            //       }
            //     }
            //     if (pagination && route.query.startIndex > 1) {
            //       newQuery = {
            //         ...newQuery,
            //         ...{
            //           startIndex: 1,
            //         },
            //       }
            //     }
            //     router.push({
            //       query: newQuery,
            //     })
            //   } else {
            //     query.value = ''
            //   }
            // }
        }
        async function onOpen() {
            console.log('XXX', 'onOpen');
            state.value = 'opened';
            ajaxIsLoading.value = true;
            ajaxError.value = null;
            options.value = [];
            query.value = '';
            try {
                const query = route.query;
                let params = {
                    articleGroup: arrayToQueryStringParameter(query.articleGroup),
                    // itemsPerPage: this.itemsPerPage,
                    language: window.settings.languageCode,
                    startIndex: parseInt(query.startIndex) >= 1 ? parseInt(query.startIndex) : 1,
                    remainders: (query.remainders === '1') ? '1' : '',
                    material: arrayToQueryStringParameter(query.material),
                    shape: arrayToQueryStringParameter(query.shape),
                    grade: arrayToQueryStringParameter(query.grade),
                    innerDiameter: arrayToQueryStringParameter(query.innerDiameter),
                    outerDiameter: arrayToQueryStringParameter(query.outerDiameter),
                    wallThickness: arrayToQueryStringParameter(query.wallThickness),
                    inStock: query.inStock === 'only' ? '1' : '0',
                    sort: query.sort || '',
                };
                if (query.articleGrouping) {
                    params.list = articleStore.groups
                        .find(({ grouping }) => grouping == query.articleGrouping)
                        ?.children.map(({ articleGroup }) => `articleGroup-${articleGroup}`).join(',');
                }
                params[__props.filterKey] = '';
                let stats = null;
                if (statsCache.has(params)) {
                    stats = statsCache.get(params);
                }
                else {
                    console.log('XXX', 'Fetch stats');
                    stats = (await axios.get(`${window.settings.siteAddress}/app/api/articles.php`, {
                        params,
                    }))?.data?.data?.stats;
                    statsCache.setIfDefined(params, stats);
                }
                options.value = Object.entries(stats[__props.filterKey] || {}).map(([key, value]) => ({
                    key,
                    label: __props.filterKeyName ? ucfirst(stats[__props.filterKeyName][key]) : ucfirst(key),
                    count: value,
                }));
            }
            catch (e) {
                ajaxError.value = e;
            }
            finally {
                ajaxIsLoading.value = false;
            }
        }
        async function onClose() {
            console.log('XXX', 'onClose');
            state.value = 'closed';
            let newQuery = { ...route.query };
            newQuery = {
                ...newQuery,
                ...{
                    [__props.filterKey]: __props.multiple
                        ? selectedOptions.value?.map(({ key }) => key)
                        : selectedOptions.value?.key,
                },
            };
            if (__props.pagination && route.query.startIndex > 1) {
                newQuery = {
                    ...newQuery,
                    ...{
                        startIndex: 1,
                    },
                };
            }
            router.push({
                query: newQuery,
            });
            //   if (trackedOpenState.open === trackedOpenState.closed) {
            //     delete newQuery[filterKey]
            //   } else {
            //     newQuery = {
            //       ...newQuery,
            //       ...{
            //         [filterKey]: multiple
            //           ? selectedOptions.value?.map(({key}) => key)
            //           : selectedOptions.value?.key,
            //       },
            //     }
            //   }
            //   if (pagination && route.query.startIndex > 1) {
            //     newQuery = {
            //       ...newQuery,
            //       ...{
            //         startIndex: 1,
            //       },
            //     }
            //   }
            //   router.push({
            //     query: newQuery,
            //   })
            // } else {
            //   query.value = ''
            // }
        }
        function updateSelectedOptions() {
            const queryOptions = asArray(route.query[__props.filterKey]);
            let newSelectedOptions = __props.filterOptions.filter(({ key }) => queryOptions.includes(key));
            if (newSelectedOptions.length === 0 && __props.defaultValue) {
                if (Array.isArray(__props.defaultValue)) {
                    newSelectedOptions = __props.defaultValue;
                }
                else {
                    newSelectedOptions = [__props.defaultValue];
                }
            }
            if (__props.multiple) {
                selectedOptions.value = newSelectedOptions;
            }
            else {
                selectedOptions.value = newSelectedOptions[0];
            }
            if (selectedOptions.value === undefined) {
                selectedOptions.value = null;
            }
        }
        const selectedOptions = ref(null);
        watch(() => [route.query, __props.filterOptions], () => {
            if (state.value === 'opened') {
                comboboxButton.value?.$el.click();
            }
            updateSelectedOptions();
        }, { immediate: true });
        updateSelectedOptions();
        const __returned__ = { $t, route, router, articleStore, options, ajaxIsLoading, ajaxError, state, comboboxButton, query, onInput, filteredOptions, trackOpenState, onOpen, onClose, updateSelectedOptions, selectedOptions, get Combobox() { return Combobox; }, get ComboboxButton() { return ComboboxButton; }, get ComboboxInput() { return ComboboxInput; }, get ComboboxOption() { return ComboboxOption; }, get ComboboxOptions() { return ComboboxOptions; }, get ChevronDownIcon() { return ChevronDownIcon; }, get MagnifyingGlassIcon() { return MagnifyingGlassIcon; }, get XMarkIcon() { return XMarkIcon; }, LoadingSpinner };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
